module.exports = __webpack_public_path__ + "img/tsangroup.d560232d.png";